'use client'
import { useMemo, type FC } from 'react'
import { useParams } from 'next/navigation'
import styled from 'styled-components'
import { useDeviceType, useMount, useTranslator } from '@/hooks'
import { createUnderline, font12, mq, vw, designGrid, font10 } from '@/styles'
import { useModal } from '@/hooks'
import { MODALS } from '@/context'

const getHighlights = links => links.map((item, idx) => {
  return <li key={idx}>
    <span>{item.name}</span>
    {item.sub && <span>{item.sub}</span>}
    {item.note && <span className='note'>{item.note}</span>}
  </li>
})

export const PreFooter:FC = () => {
  const { t } = useTranslator()
  const { size:{ width } } = useDeviceType()
  const HighLights = useMemo(() => getHighlights(t('project.prefooter.highlights')), [t])
  const isMount = useMount()
  const { toggle } = useModal(MODALS.BENEFITS)
  const { lang } = useParams()

  return (
    <PreFooterStyled>
      {width >= 768 && isMount &&
        <ul>
          {HighLights}
          <a href={`https://reservations.portellapalma.com/${lang}/hotel/portellapalma`} rel='noreferrer noopener' target='_blank'>{t('project.prefooter.cta')}</a>
        </ul>
      }
      {width < 768 && isMount &&
        <div className='only-desktop'>
          <p>{t('project.prefooter.title')}</p>
          <button onClick={toggle}>{t('project.prefooter.action')}</button>
        </div>
      }
    </PreFooterStyled>
  )
}


const PreFooterStyled = styled.div`
	background-color: var(--color-background);
  ${designGrid({})}
	margin-top: 50px;

	${mq.greaterThan('tablet')} {
		bottom: 0;
		margin-top: 0;
		position: sticky;
		z-index: 200;
	}

  > ul {
    align-items: center;
    border-top: 1px solid rgba(60, 60, 59, 0.15);
    display: flex;
    flex-direction: row;
    gap: 10px;
    grid-column: 1 / span 6;
    padding: ${vw(15, 'mobile')} ${vw(20, 'mobile')};

    ${mq.greaterThan('tablet')} {
      gap: 0;
      grid-column: 1 / span 12;
      padding: ${vw(15, 'desktop')} ${vw(20, 'desktop')};
    }

    li {
      border-left: 1px solid rgba(0,0,0,0.1);
      align-items: center;
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
      line-height: 110%;
      width: 20%;

      &:first-of-type {
        border-left: none;
      }

      ${mq.greaterThan('tablet')} {
        padding: 0 ${vw(10, 'desktop')};
      }

      ${mq.greaterThan('desktop')} {
        padding: 0 10px;
      }

      > span {
        ${font12(true)}
        text-align: center;
        line-height: inherit !important;

        ${mq.greaterThan('tablet')} {
          ${font12(false)}
        }

        &.note {
          margin-top: 5px;
          opacity: .6;
        }
      }
    }

    > button, > a {
      ${font12(true)}
      background-color: var(--color-text);
      border: 1px solid var(--color-text);
      color: var(--color-background);
      padding: 15px ${vw(30, 'mobile')};
      transition: 300ms background-color linear, 300ms color linear;
      text-transform: uppercase;
      text-align: center;
      width: 20%;

      ${mq.greaterThan('tablet')} {
        ${font12(false)}
        padding: 15px ${vw(30, 'desktop')};
      }

      &:hover {
        border: 1px solid #000;
        background-color: #000;
        color: var(--color-background);
      }
    }
  }

  > div {
    align-items: center;
    border-top: 1px solid rgba(60, 60, 59, 0.15);
    display: flex;
    flex-direction: column;
    gap: 3px;
    grid-column: 1 / span 6;
    justify-content: center;
    margin-top: ${vw(30, 'mobile')};
    padding: ${vw(25, 'mobile')} ${vw(20, 'mobile')};
    width: 100%;

		&.only-desktop {
			${mq.lessThan('tablet')} {
				display: none;
			}
		}

    p {
      ${font10(true)}
      text-align: center;
      text-transform: uppercase;

      ${mq.greaterThan('tablet')} {
        ${font12(false)}
      }
    }

    button {
      ${font12(true)}
      ${createUnderline({ reverse: true})}
      align-items: center;
      display: flex;
      justify-content: center;

      ${mq.greaterThan('tablet')} {
        ${font12(false)}
      }
    }
  }

`
